import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

interface QueuedRequest {
  request: HttpRequest<any>;
  next: HttpHandler;
  observer: any;
}

@Injectable()
export class GraphAvatarLimitInterceptor implements HttpInterceptor {
  private MAX_CONCURRENT_REQUESTS = 4;
  private activeRequests = 0;
  private requestQueue: QueuedRequest[] = [];

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const allowedHosts = ['graph.microsoft.com', 'ms-graph-api-adapter'];
    if (URL.canParse(req.url) && allowedHosts.includes(new URL(req.url).host) && req.url.includes('photo')) {
      return new Observable<HttpEvent<any>>((observer) => {
        const queuedRequest: QueuedRequest = {
          request: req,
          next,
          observer,
        };

        if (this.activeRequests < this.MAX_CONCURRENT_REQUESTS) {
          this.processRequest(queuedRequest);
        } else {
          this.requestQueue.push(queuedRequest);
        }
      });
    } else {
      return next.handle(req);
    }
  }

  private processRequest(queuedRequest: QueuedRequest): void {
    this.activeRequests++;
    queuedRequest.next
      .handle(queuedRequest.request)
      .pipe(
        finalize(() => {
          this.activeRequests--;
          this.executeNextRequest();
        }),
      )
      .subscribe(
        (event: HttpEvent<any>) => queuedRequest.observer.next(event),
        (error: any) => queuedRequest.observer.error(error),
        () => queuedRequest.observer.complete(),
      );
  }

  private executeNextRequest(): void {
    if (this.requestQueue.length > 0) {
      const nextRequest = this.requestQueue.shift();
      if (nextRequest) {
        this.processRequest(nextRequest);
      }
    }
  }
}
